// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_f7-0";
export var fileCarousel = "_f7-2";
export var removeFileButton = "_f7-1";